// src/components/WorkSchedule.jsx
import React from "react";
import styles from "./WorkSchedule.module.css";

function WorkSchedule({ segments }) {
  if (!segments || segments.length === 0) {
    return <div className={styles.scheduleContainer}>Brak harmonogramu</div>;
  }

  return (
    <div className={styles.scheduleContainer}>
      {segments.map((segment, index) => {
        // Szerokość segmentu zaokrąglona do części całkowitej
        const segmentWidth = Math.floor(segment.width);
        // Ustalamy klasę CSS na podstawie typu segmentu
        let segmentClass = styles.scheduleSegment;
        if (segment.type === "working") {
          segmentClass = `${segmentClass} ${styles.workingSegment}`;
        } else if (segment.type === "break") {
          segmentClass = `${segmentClass} ${styles.breakSegment}`;
        } else if (segment.type === "off") {
          segmentClass = `${segmentClass} ${styles.offSegment}`;
        }
        return (
          <div
            key={index}
            className={segmentClass}
            style={{ width: `${segmentWidth}%` }}
            title={`Typ: ${segment.type}, szerokość: ${segmentWidth}%`}
          ></div>
        );
      })}
    </div>
  );
}

export default WorkSchedule;
